let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2DNIK"), load("8JZKd"), load("kTv6A"), load("aez9w")]).then(() => parcelRequire('cjovp'));